const formatSquareMeters = (m2: number): string => `${m2.toLocaleString("pl-PL", { maximumFractionDigits: 0 })} m²`;

function parseSquareMetersInput(raw: string): number | null {
	const trimmed = raw.replace(",", ".").trim();

	if (trimmed === "") {
		return null;
	}

	const parsed = Number(trimmed);

	if (Number.isFinite(parsed) === false || parsed < 0) {
		return null;
	}

	return parsed;
}

function squareMetersToInputValue(m2: number | null): string {
	if (m2 === null) {
		return "";
	}

	return String(Math.round(m2));
}

export { formatSquareMeters, parseSquareMetersInput, squareMetersToInputValue };
